export const mapSalons = async salonList =>
  await salonList.map(salon => salon.sid);

export const generatePin = () =>
  Math.floor(Math.random() * 1000000)
    .toString()
    .padEnd(6, '0');
